<script setup lang="ts">
    const { isUS } = useLocales();
    const dealerUrl = ref(isUS.value ? 'https://us-checkout.woom.com/apps/store-locator' : 'https://eu-checkout.woom.com/apps/dealerlocator');
</script>
<template>
    <nuxt-link
        :to="dealerUrl"
        target="_blank"
        class="atm-dealer-button gap-3 text-base transition-colors hover:text-woom-red max-lg:flex max-lg:items-center max-lg:py-3 lg:p-1">
        {{ $t('dealerLocator') }}
    </nuxt-link>
</template>
